import { FC } from 'react';

export const Flag: FC = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.4"
    strokeLinecap="round"
    strokeLinejoin="round">
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M5 21v-16" />
    <path d="M5 4h13l-3 4l3 4h-13" />
  </svg>
);

export default Flag;
